import React from 'react';
import CustomModal from '../../../components/custom-modal/CustomModal';
import CustomButton, { ButtonType } from '../../../components/custom-button/CustomButton';
import { AccountIcon, NavCloseIcon, SecureDataIcon, TaxIdIcon, TeamCreationIllustration } from '../../../assets/icons';

interface TeamInfoItem {
  icon: React.FC<{ className?: string }>;
  text: React.ReactNode;
}

const TEAM_INFO_ITEMS: TeamInfoItem[] = [
  {
    icon: TaxIdIcon,
    text: (
      <>
        You need a unique <span className="font-bold">EIN or Tax ID number </span>to create a new team
      </>
    )
  },
  {
    icon: AccountIcon,
    text: <>Each team has its own ScanPay banking account to receive payouts</>
  },
  {
    icon: SecureDataIcon,
    text: <>All data will be separate and unique to each team</>
  }
];

interface CreateNewTeamPopupProps {
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
}

const CreateNewTeamPopup: React.FC<CreateNewTeamPopupProps> = ({ open, onClose, onContinue }) => {
  return (
    <CustomModal open={open} closeModal={onClose} className="max-w-[90vw] md:w-[415px]">
      <div className="relative flex flex-col items-center p-6">
        <NavCloseIcon className="absolute top-4 right-4 cursor-pointer" onClick={onClose} />
        <TeamCreationIllustration className="mb-6" />
        <h2 className="mb-[6px] text-xl font-bold text-headingGray">Ready to create a new team?</h2>
        <p className="mb-3 text-sbase font-normal text-accentText">3 things to know</p>

        <div className="mb-8 flex w-full flex-col divide-y divide-borderGray text-17px">
          {TEAM_INFO_ITEMS.map((item, index) => (
            <div key={index} className="flex items-start gap-2 py-5">
              <item.icon className="shrink-0" />
              <p className="font-normal text-primaryText">{item.text}</p>
            </div>
          ))}
        </div>

        <div className="flex w-full flex-col gap-3">
          <CustomButton
            id="continue-create-team"
            type={ButtonType.PRIMARY}
            className="h-12 w-full"
            childrenContainerStyles="text-17px"
            onClick={onContinue}>
            Continue
          </CustomButton>
          <CustomButton
            id="cancel-create-team"
            type={ButtonType.SECONDARY}
            className="h-12 w-full"
            childrenContainerStyles="text-17px"
            onClick={onClose}>
            Cancel
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default CreateNewTeamPopup;
